import { Entity } from '../entity.js';
import { isInAbilityLine, isWithinAbilityRange } from '../combat/abilityArea.js';
import {
  YASUO_W_DURATION_SEC,
  createWindWall
} from './yasuoWindWall.js';
import { applySweepingBlade } from './yasuoSweepingBlade.js';

/** Steel Tempest slash vs tornado (FID-ABL-15). */
export const YASUO_Q_SLASH_RANGE = 450;
export const YASUO_Q_TORNADO_RANGE = 1000;
export const YASUO_Q_TORNADO_SPEED = 1200;
export const YASUO_Q_HALF_WIDTH = 40;
export const YASUO_Q_STACK_WINDOW_SEC = 6;

function pushSkillshot(bucket, caster, tx, ty, gameTime, opts) {
  const angle = Math.atan2(ty - caster.y, tx - caster.x);
  bucket.push({
    id: `${opts.idPrefix}-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * opts.speed,
    vy: Math.sin(angle) * opts.speed,
    range: opts.range,
    traveled: 0,
    damage: opts.damage,
    damageType: opts.damageType || 'physical',
    radius: opts.radius || 16
  });
}

export function createYasuo(id = 'yasuo-1', team = 'blue', x = 300, y = 1300) {
  return new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 590,
    maxMp: 100,
    ad: 61,
    ap: 0,
    armor: 31,
    mr: 32,
    ms: 345,
    attackRange: 175,
    attackSpeed: 0.67,
    name: 'Yasuo',
    radius: 20
  });
}

function steelTempestStacks(caster, nowSec) {
  const last = Number(caster.yasuoQLastAt);
  const stacks = Number(caster.yasuoQStacks) || 0;
  if (!Number.isFinite(last) || nowSec - last > YASUO_Q_STACK_WINDOW_SEC) return 0;
  return stacks;
}

function slashSteelTempest(caster, tx, ty, entities) {
  const angle = Math.atan2(ty - caster.y, tx - caster.x);
  const damage = 60 + (caster.ad || 0) * 1.0;
  let hit = false;
  for (const e of entities || []) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityLine(
      e, caster.x, caster.y, angle, YASUO_Q_SLASH_RANGE, YASUO_Q_HALF_WIDTH, caster
    )) continue;
    e.takeDamage(damage, caster, 'physical');
    hit = true;
  }
  return hit;
}

export function castYasuoQ(caster, tx, ty, projectiles, gameTime, entities = []) {
  if (!caster || caster.isDead) return false;
  const t = Number(gameTime) || 0;
  const stacks = steelTempestStacks(caster, t);
  if (stacks >= 2) {
    pushSkillshot(projectiles, caster, tx, ty, gameTime, {
      idPrefix: 'yasuo-q-tornado',
      speed: YASUO_Q_TORNADO_SPEED,
      range: YASUO_Q_TORNADO_RANGE,
      damage: 60 + (caster.ad || 0) * 1.0,
      radius: YASUO_Q_HALF_WIDTH
    });
    caster.yasuoQStacks = 0;
    caster.yasuoQLastAt = t;
    return true;
  }
  if (slashSteelTempest(caster, tx, ty, entities)) {
    caster.yasuoQStacks = stacks + 1;
    caster.yasuoQLastAt = t;
  }
  return true;
}

export function castYasuoW(caster, tx, tz, nowSec = 0) {
  if (!caster || caster.isDead) return false;
  caster.buffs = caster.buffs || [];
  caster.buffs.push({ id: 'wind_wall', duration: YASUO_W_DURATION_SEC });
  caster.windWall = createWindWall(caster, tx, tz, nowSec);
  return true;
}

export function castYasuoE(caster, tx, ty, entities = []) {
  if (!caster || caster.isDead) return false;
  return applySweepingBlade(caster, tx, ty, entities);
}

export function castYasuoR(caster, target) {
  if (!caster || caster.isDead || !target || target.isDead) return false;
  if (!isWithinAbilityRange(caster, target, 1400, caster)) return false;
  target.takeDamage(200 + (caster.ad || 0) * 1.5, caster, 'physical');
  return true;
}
